/* 🤖 this file was generated by svg-to-ts */
export const matIconPermDeviceInformation: {
  name: 'perm-device-information';
  data: string;
} = {
  name: 'perm-device-information',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11 7h2v2h-2zm0 4h2v6h-2zm6-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7z"/></svg>`
};
